"use client"

import type React from "react"
import { Inter } from "next/font/google"
import "./globals.css"
import { Providers } from "@/app/components/providers"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

const inter = Inter({ subsets: ["latin"] })

export default function ClientLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const pathname = usePathname()

  useEffect(() => {
    // Check if the URL has a hash (anchor)
    // If not, scroll to the top of the page
    if (!window.location.hash) {
      window.scrollTo(0, 0)
    }
    // If there is a hash, the browser's default behavior or
    // our custom anchor scrolling logic (in legal pages) will handle it.
  }, [pathname]) // Rerun effect when pathname changes

  return (
    <Providers>
      <div className="flex flex-col min-h-screen">{children}</div>
    </Providers>
  )
}
